"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Handle = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const handleStyles = {
    position: 'absolute',
    marginLeft: '-12px',
    marginTop: '5px',
    width: 20,
    height: 20,
    cursor: 'pointer',
    border: '1px solid',
    borderRadius: '50%',
    backgroundColor: 'white',
    zIndex: 1,
};
const SliderWrapper = styled_components_1.default.div.attrs({
    role: 'slider',
})(handleStyles, ({ disabled, percent, theme: { colors } }) => ({
    borderColor: disabled ? colors.secondary : colors.primary,
    left: `${percent}%`,
}));
const Handle = props => {
    const { disabled = false, domain: [min, max], handle: { value, percent }, movingTooltip, handleEvents, } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SliderWrapper, Object.assign({ disabled: disabled, percent: percent, "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value }, handleEvents), movingTooltip)));
};
exports.Handle = Handle;
//# sourceMappingURL=Handle.js.map